import * as Sentry from "@sentry/react";
import ReactDOM from 'react-dom/client';
import App from './App';
import Header from './components/Header';
import Menu from './components/Menu';
import Footer from './components/Footer';
import LoginPage from './pages/LoginPage';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import React, { Fragment } from 'react';
import '@mui/material/styles';

// CACHES
import CacheBuster from 'react-cache-buster';
import { Provider, useDispatch } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { store, persistor } from './Redux/store'


import Cookies from 'universal-cookie'
import { useNavigate } from 'react-router-dom';
import { LogoutUser } from './Redux/UsersDucks';
//import generateStore from './Redux/store'

Sentry.init({
  dsn: "https://ad7975fb24756a8b98a174b22d6fc5cd@o4510244498440192.ingest.us.sentry.io/4510262820536320",
  sendDefaultPii: true,
  environment: "staging",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration()
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^http:\/\/172\.16\.10\.35:8062\/api/, /^http:\/\/172\.16\.10\.35:8013\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling for session replays, you may want to consider doing so for error events.
  enableLogs: true
});

const root = ReactDOM.createRoot(document.getElementById('root'));

function MiddlewareProvider({ children }) {
    const location = useLocation();
    const dispatch = useDispatch()
    const navigate = useNavigate()

    // Este useEffect se ejecuta solo una vez
    React.useEffect(() => {
        const cookies = new Cookies();

        var exp = cookies.get('expirationTime');
        var expirationTime = null;

        if (typeof exp === "number") {
            expirationTime = exp * 1000;
        } else if (typeof exp === "string") {
            expirationTime = new Date(exp).getTime();
        }

        if (expirationTime) {
            const isExpired = Date.now() >= expirationTime;
            if (isExpired) {
                dispatch(LogoutUser())
                navigate("/")
                return
                // aquí podrías redirigir o eliminar la cookie
            }
        }
        if (cookies.get('identifier') == null) {
            dispatch(LogoutUser())
            navigate("/")
            return
        }


    }, [location]);

    return children;
}

//const store = generateStore()

root.render(
    <CacheBuster
        currentVersion={"0.9.5.3"}
        isEnabled={true} //If false, the library is disabled.
        isVerboseMode={true} //If true, the library writes verbose logs to console.
        loadingComponent={<CircularProgress />} //If not pass, nothing appears at the time of new version check.
        metaFileDirectory={'.'} //If public assets are hosted somewhere other than root on your server.
    >
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>

                <BrowserRouter>
                    <Routes>
                        <Route path='/' element={<LoginPage />} />
                        <Route path='*' element={
                            <MiddlewareProvider>
                                <Fragment>
                                    <Header />
                                    <div className="d-flex align-items-stretch">
                                        <Menu />
                                        <div className="page-holder bgPrincipalColor">
                                            <div className="container-fluid px-lg-0 px-xl-4">
                                                <App />
                                            </div>
                                            <Footer />
                                        </div>
                                    </div>
                                </Fragment>
                            </MiddlewareProvider>} />
                    </Routes>
                </BrowserRouter>
            </PersistGate>
        </Provider>
    </CacheBuster >
);

